import { render } from "./SearchEstatesForm.vue?vue&type=template&id=55710437&ts=true"
import script from "./SearchEstatesForm.vue?vue&type=script&lang=ts"
export * from "./SearchEstatesForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__